/* global advAppData, buildAppUrl, Vue, grecaptcha */
/* eslint no-undef: "error" */

let recaptchaV2Rendered = false

/**
 * Resolves the captcha tokens the waiting-list endpoint expects, then hands
 * them to `callback(v2Token, v3Token)`.
 *
 * reCAPTCHA v3 runs invisibly whenever the hidden `#g-recaptcha-v3-response`
 * field is present - its data-sitekey/data-action come from
 * GoogleRecaptchaTrait::getCaptchaClientMarkup(). When v3 is not configured
 * that field does not exist at all, so this reads `#g-recaptcha-response`
 * synchronously and reports "no v3 field" as a null token, which keeps the POST
 * body identical to what it was before v3 existed.
 */
function resolveWaitingListCaptchaTokens (callback) {
  const v3Field = document.getElementById('g-recaptcha-v3-response')
  const v2Token = $('#g-recaptcha-response').val() || ''

  if (!v3Field) {
    callback(v2Token, null)
    return
  }

  // The token is delivered exactly once: a synchronous throw out of the
  // grecaptcha calls below must not be able to submit twice, nor to leave the
  // submit hanging with no feedback at all.
  let settled = false
  const settle = function (v3Token) {
    if (settled) {
      return
    }
    settled = true
    callback(v2Token, v3Token)
  }

  if (typeof grecaptcha === 'undefined' || typeof grecaptcha.ready !== 'function') {
    settle('')
    return
  }

  // data-action is the generic source; 'waiting_list' is only the fallback for a
  // stripped/empty attribute, since that is the one surface this handler serves.
  const v3Action = v3Field.dataset.action || 'waiting_list'

  // A synchronous throw (unloaded/invalid site key) bypasses the promise chain
  // entirely, so `.catch()` alone would leave a dead button with no message.
  // Falling through with an empty v3 token instead makes the server fail closed
  // with a visible error, which is the recoverable failure mode.
  try {
    grecaptcha.ready(function () {
      try {
        grecaptcha.execute(v3Field.dataset.sitekey, { action: v3Action })
          .then(settle)
          .catch(function () {
            settle('')
          })
      } catch (e) {
        settle('')
      }
    })
  } catch (e) {
    settle('')
  }
}

/**
 * Reveals and explicitly renders the pre-rendered (hidden, bare-div) v2 step-up
 * widget in place, so the shopper can retry without a page reload. Rendering is
 * one-shot - grecaptcha.render() throws when asked to render a container twice.
 */
function revealRecaptchaV2StepUp () {
  const container = document.getElementById('recaptchaV2Container')

  if (!container || recaptchaV2Rendered ||
    typeof grecaptcha === 'undefined' || typeof grecaptcha.render !== 'function' ||
    !container.dataset.sitekey) {
    return
  }

  recaptchaV2Rendered = true
  container.style.display = 'block'

  try {
    grecaptcha.render(container, { sitekey: container.dataset.sitekey })
  } catch (e) {
    // Nothing actionable client-side; the step-up message is already shown.
  }
}

function actionWaitingListSubmit (email, product, v2Token, v3Token, formBlock) {
  const postData = { email: email, product: product, 'g-recaptcha-response': v2Token }

  // Sent only when v3 is configured, so the v3-off path posts exactly the
  // fields it always did.
  if (v3Token !== null) {
    postData['g-recaptcha-v3-response'] = v3Token
  }

  $.ajax({
    type: 'POST',
    url: advAppData.productPage.waitingListAddUri,
    data: postData,
    dataType: 'json'
  }).done(function (data, textStatus, jqXHR) {
    if (data.status === 'captcha_step_up') {
      // Message first: a throw out of the widget render must not swallow it.
      Vue.$toasted.error(data.msg)
      revealRecaptchaV2StepUp()
      return
    }

    let toastedPrintMethod = 'error'
    if (data.status === 'success') {
      toastedPrintMethod = 'success'
      formBlock.fadeOut()
    }
    Vue.$toasted[toastedPrintMethod](data.msg)
  })
}

$(document).ready(function () {
  $('[data-action="waitinglist-form-submit"]').on('click', function () {
    const target = $('#' + $(this).data('target')[0])
    const email = target.val()
    const productId = target.data('product_id')
    const formBlock = $('#' + $(this).data('target')[1])

    resolveWaitingListCaptchaTokens(function (v2Token, v3Token) {
      actionWaitingListSubmit(email, productId, v2Token, v3Token, formBlock)
    })
  })

  /* https://codepen.io/mmoradi08/pen/yLyYrGg */
  /* 1. Visualizing things on Hover - See next part for action on click */
  $('#stars li').on('mouseover', function () {
    var onStar = parseInt($(this).data('value'), 10); // The star currently hovered

    // Now highlight all the stars up to the hovered one
    $(this).parent().children('li.star').each(function (e) {
      if (e < onStar) {
        $(this).addClass('hover');
        $(this).find('i').removeClass('lni-star').addClass('lni-star-filled');
      } else {
        $(this).removeClass('hover');
        $(this).find('i').removeClass('lni-star-filled').addClass('lni-star');
      }
    });
  }).on('mouseout', function () {
    // Reset hover effect when the mouse leaves
    $(this).parent().children('li.star').each(function () {
      if (!$(this).hasClass('selected')) { // Only reset if not selected
        $(this).removeClass('hover');
        $(this).find('i').removeClass('lni-star-filled').addClass('lni-star');
      }
    });
  }).on('click', function () {
    const onStar = parseInt($(this).data('value'), 10); // The star currently selected
    const stars = $(this).parent().children('li.star');

    stars.each(function (i) {
      $(this).removeClass('selected');
      $(this).find('i').removeClass('lni-star-filled').addClass('lni-star'); // Reset all
    });

    for (let i = 0; i < onStar; i++) {
      $(stars[i]).addClass('selected');
      $(stars[i]).find('i').removeClass('lni-star').addClass('lni-star-filled'); // Fill selected stars
    }

    const ratingValue = parseInt($('#stars li.selected').last().data('value'), 10);
    (ratingValue > 1) ? $('#star_input').val(ratingValue) : $('#star_input').val('');
  });

  $('#review_submit').on('click', function (e) {
    e.preventDefault()
    const ratingValue = $('#star_input').val()
    if (ratingValue >= 1) {
      $.ajax({
        type: 'POST',
        url: buildAppUrl(advAppData.uris.submitProductReview),
        dataType: 'json',
        data: {
          product_id: advAppData.productPage.productId,
          review_rating: ratingValue,
          review_name: $('#reviewname').val(),
          review_text: $('#reviewtext').val()
        },
        complete: function (data) {
          if (data.responseJSON.status === '1') {
            $('.reviews-content-wrapper').html('')
            $('.reviews-content-wrapper').html(advAppData.markup.productPageReviewsAjaxResponseSuccess)
          }
          if (data.responseJSON.status === '0') {
            $('.reviews-content-wrapper').html('')
            $('.reviews-content-wrapper').html(advAppData.markup.productPageReviewsAjaxResponseFail)
          }
        }
      })
    }
  })
})

// $('.suggest-prod-slider').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 1,
//   slidesToScroll: 1
// })

$('#launch-review-write, #js-reviews-toggle').on('click', function () {
  $('html, body').animate({
    scrollTop: $('#product-page-tabs').offset().top - 200
  }, 2000)
  $('#product-page-tabs ul.prod-tabs li').removeClass('current')
  $('#product-page-tabs .tab-content').removeClass('current')
  $('#product-page-tabs .tab-content#tab-4').addClass('current')
  $('#product-page-tabs ul.prod-tabs li[data-tab="tab-4"]').addClass('current')
  return false
})
/*
$('.prod-gallery-row').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
        arrows: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
})

$('.combo-prod-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})
*/
/*$('.product_tabs').slick({
  dots: false,
  infinite: false,
  speed: 300,
  arrows: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 768,
      settings: 'unslick'
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1
      }
    }
  ]
})*/

// Product Page Tabs
document.addEventListener('DOMContentLoaded', function() {
  const tabLinks = document.querySelectorAll('.prod-page-tab-link');

  tabLinks.forEach(tabLink => {
    tabLink.addEventListener('click', function(event) {
      event.preventDefault();

      const tabId = this.dataset.tab; // Get the target tab ID from the data-tab attribute

      document.querySelectorAll('.prod-page-tab-link').forEach(link => {
        link.classList.remove('current');
      });
      document.querySelectorAll('.tab-content').forEach(content => {
        content.classList.remove('current');
      });

      this.classList.add('current');
      document.getElementById(tabId).classList.add('current');
    });
  });
});

